module.exports = __webpack_public_path__ + "img/logo_ue_blanco.835d1a95.png";